<script context="module" lang="ts">
	export interface ItemInteface {
		getTranslation: () => TranslationDTO[];
		getPrice: () => number;
		getStockAvailable: () => boolean;
		getStock: () => number;
		getBarcodeAvailable?: () => boolean;
		getBarcode?: () => null | string;
		id?: string;
	}
</script>

<script lang="ts">
	import type { TranslationDTO } from "../../class/TranslationDTO";
	import {
		Card,
		InlineButton,
		DefaultCheckbox,
		XIcon,
	} from "@hitit/new_ui/src";
	import { createEventDispatcher } from "svelte";
	import { formatKrwNumber, getKeyInTranslation } from "../../utils";
	import { t } from "@hitit/hub/src/stores";
	export let selected = false;
	export let editmode = false;
	export let multipleSelectMode = false;
	export let item: ItemInteface;

	const dispatch = createEventDispatcher();
	const deleteClickEvent = () => {
		console.log("Delete");
		dispatch("ITEM_DELETE_CLICK_EVENT", item);
	};
	const multipleSelectEvent = () => {
		console.log("multi");
		dispatch("ITEM_MULTIPLE_SELECT_CLICK", item);
	};

	const itemClickEvent = () => {
		console.log("click");
		dispatch("ITEM_CLICK_EVENT", item);
	};

	function containerClickEvent() {
		if (multipleSelectMode) {
			multipleSelectEvent();
		} else {
			itemClickEvent();
		}
	}
</script>

<div
	id={item.id}
	class="container item"
	class:editmode={editmode}
	class:multipleSelectMode={multipleSelectMode}
	class:selected={editmode && multipleSelectMode && selected}
	on:click|stopPropagation={containerClickEvent}
>
	<div class="grow">
		<Card noPadding>
			<div class="inner">
				<div class="barcode-name">
					{#if item.getBarcodeAvailable && item.getBarcodeAvailable()}
						<div class="barcode" />
					{/if}
					<span class="name">
						{getKeyInTranslation(item.getTranslation(), "name", "ko") || ""}
					</span>
				</div>
				<div class="price-stock" class:withStock={item.getStockAvailable()}>
					<span class="price"
						>{formatKrwNumber(item.getPrice())}{$t("global.KRW")}</span
					>
					{#if item.getStockAvailable()}
						<span class="stock"
							>{`${formatKrwNumber(item.getStock())}${$t("global.EA")}`}</span
						>
					{/if}
				</div>
				{#if editmode}
					{#if multipleSelectMode}
						<div
							class="checkbox"
							on:click|stopPropagation={multipleSelectEvent}
						>
							<DefaultCheckbox checked={selected} />
						</div>
					{:else}
						<div class="delete">
							<InlineButton on:click={deleteClickEvent}>
								<div class="delete-inner">
									<XIcon />
								</div>
							</InlineButton>
						</div>
					{/if}
				{/if}
			</div>
		</Card>
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	:global(.container.found) {
		animation-direction: alternate;
		animation-duration: 0.5s;
		animation-iteration-count: infinite;
		animation-name: found;
		border-radius: 5px;
	}
	@keyframes found {
		from {
			border: 1px solid #6b94f300;
		}
		to {
			border: 1px solid #6b93f3;
		}
	}
	.container {
		&:hover {
			cursor: pointer;
		}
		* {
			letter-spacing: -0.64px;
		}
		display: flex;
		width: 100%;
		max-width: 100%;
		min-height: 83px;
		box-sizing: border-box;
		&.selected {
			border-radius: 5px;
			border: 1px solid #6b93f3;
		}
		.price-stock {
			display: flex;
			flex-wrap: nowrap;
			justify-content: space-between;
			color: #46474b;
		}

		.barcode-name {
			display: flex;
			font-weight: 500;
			font-size: 1.25rem;
			color: #46474b;

			.barcode {
				min-width: 25px;
				height: 20px;
				margin-right: 6px;
				background-color: red;
			}
		}

		span {
			word-break: break-all;
		}

		.grow {
			flex-grow: 1;
		}

		.inner {
			width: 100%;
			display: flex;
			flex-direction: column;
			padding: 10px;
			gap: 23px;
			&.editmode {
				position: relative;
			}
		}

		.checkbox {
			width: 26px;
			height: 26px;
		}
		.checkbox,
		.delete {
			position: absolute;
			top: 10px;
			right: 10px;

			.delete-inner {
				width: 20px;
				height: 20px;
			}
		}
	}

	@include DesktopSize {
		.container {
			width: 300px;
			min-height: 130px;
			* {
				letter-spacing: -0.8px;
			}
			.inner {
				padding: 20px;
				gap: 0px;
				justify-content: space-between;
				max-width: 100%;
				box-sizing: border-box;
			}

			.price-stock {
				max-width: 100%;
				font-size: 1.25rem;
				span {
					overflow: hidden;
					word-break: keep-all;
					text-overflow: ellipsis;
					max-width: 100%;
				}

				&.withStock {
					.price {
						max-width: 60%;
					}
					.stock {
						max-width: 40%;
					}
				}
			}

			.grow {
				max-width: 100%;
			}
		}
	}
</style>
